import { render } from "./two-fa.vue?vue&type=template&id=cc254668&scoped=true"
import script from "./two-fa.vue?vue&type=script&lang=js"
export * from "./two-fa.vue?vue&type=script&lang=js"

import "./two-fa.vue?vue&type=style&index=0&id=cc254668&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc254668"]])

export default __exports__